import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { SplashScreen } from '../components/SplashScreen';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Carousel } from '../components/Carousel';
import { Services } from '../components/Services';
import { WarehouseRentals } from '../components/WarehouseRentals';
import { Advantages } from '../components/Advantages';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [showSplash, setShowSplash] = useState(true);
  return <div className="w-full min-h-screen bg-black" data-id="element-253">
      <AnimatePresence mode="wait" data-id="element-254">
        {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} data-id="element-255" />}
      </AnimatePresence>

      {!showSplash && <>
          <Navbar data-id="element-256" />
          <div id="inicio" data-id="element-257">
            <Hero data-id="element-258" />
          </div>
          <Carousel data-id="element-259" />
          <Services data-id="element-260" />
          <WarehouseRentals data-id="element-261" />
          <div id="advantages" data-id="element-262">
            <Advantages data-id="element-263" />
          </div>
          <Contact data-id="element-264" />
          <Footer data-id="element-265" />
        </>}
    </div>;
}